<section class="content">
    <app-alerts-components
            [type]="'danger'"
            [disableClose]="true"
            [icon]="'fa fa-trash'"
            [id]="'delete_user_account'"
            [title]="'delete_user_account_title' | localise"
            [message]="'delete_user_account_text' | localise"></app-alerts-components>

    <button (click)="deleteAccount()" class="btn btn-danger btn-sm delete-btn">
        {{ 'delete_user_account_btn' | localise }}
    </button>

    <button (click)="onWebChat()" class="btn btn-success btn-sm delete-btn">
        {{ 'chat_with_operator' | localise }}
    </button>

</section>
